import { useEffect, useState } from "react";
import axios from "v2/utils/axios";
import { SlaActiveFilters, SlaAssignee } from "../types";

interface UseSlaTeamMembersResult {
  members: SlaAssignee[];
  isLoading: boolean;
  error: Error | null;
}

export function useSlaTeamMembers(
  filters: SlaActiveFilters,
  propertyId?: string
): UseSlaTeamMembersResult {
  const [members, setMembers] = useState<SlaAssignee[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    let cancelled = false;
    setIsLoading(true);
    setError(null);

    const params: Record<string, any> = {};
    if (filters.dateRangePreset) {
      params.date_range_preset = filters.dateRangePreset;
    } else {
      if (filters.startDate) params.start_date = filters.startDate;
      if (filters.endDate)   params.end_date   = filters.endDate;
    }
    if (propertyId) params.property_id = propertyId;

    axios
      .get(`${process.env.REACT_APP_API_ENDPOINT_V2}sla_dashboard/team_members`, { params })
      .then((res) => {
        if (cancelled) return;
        const data = (res.data?.data ?? []) as SlaAssignee[];
        setMembers(data);
      })
      .catch((err) => {
        if (cancelled) return;
        setError(err);
        setMembers([]); // empty dropdown on error — same fail-graceful pattern as the old code
      })
      .finally(() => {
        if (!cancelled) setIsLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [
    filters.dateRangePreset,
    filters.startDate,
    filters.endDate,
    propertyId,
  ]);

  return { members, isLoading, error };
}
